var render = function render(){var _vm=this,_c=_vm._self._c;return _c('binds-toolbar',{staticClass:"binds-table-toolbar binds-transparent",attrs:{"binds-elevation":0}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }